/** Changes presentation on the existing nodes, preserving forms, quantities and variant selection. */
if (typeof document !== 'undefined') {
  const key = 'ss-favorites-view-v1';
  document.querySelectorAll('ss-favorites-grid:not([data-render-mode])').forEach((root) => {
    const controls = root.querySelector('[data-ss-favorites-views]');
    if (!controls || controls.dataset.initialized) return;
    controls.dataset.initialized = 'true';
    const apply = (view) => {
      root.dataset.ssFavoritesView = view === 'list' ? 'list' : 'grid';
      controls.querySelectorAll('[data-view]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.view === root.dataset.ssFavoritesView));
      });
    };
    let preferred = 'grid';
    try { preferred = localStorage.getItem(key) || 'grid'; } catch { /* Storage can be unavailable. */ }
    apply(preferred);
    controls.addEventListener('click', (event) => {
      const button = event.target.closest('[data-view]');
      if (!button) return;
      apply(button.dataset.view);
      try { localStorage.setItem(key, root.dataset.ssFavoritesView); } catch { /* Keep this session usable. */ }
    });
  });
}
